<template>
  <div class="cp-set-menu-preface main">
    <div class="divider" />
    <div class="row">
      <p><i class="fa fa-book icon" />Menu Preface - TODO</p>
      <p class="value">The Menu Preface appears above your menu.</p>
      <p class="value">
        You can enter information about your shop or menu that might be useful
        to customers.
      </p>
      <p class="hint">
        For example: specials, events, prep times or your brand story.
      </p>
      <div v-for="l in languages" :key="l" style="margin-top: 10px">
        <p class="has-text-right has-text-grey">{{ l.toUpperCase() }}</p>
        <textarea
          class="textarea"
          v-model="website"
          :placeholder="`${l.toUpperCase()} Menu Preface`"
          rows="2"
        />
      </div>

      <div class="save-wrapper">
        <p v-if="updatingPreface" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="savePreface">Save</p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "CPSetMenuPreface",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      website: null,
      updatingPreface: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    languages() {
      return this.commerce.data.languages || ["en", "th"]; // otherwise show default languages...
    },
  },
  mounted() {
    this.website = this.business.data.website;
  },
  methods: {
    initBlobs(blobs) {
      // init preface
      this.menuPreface = blobs.find((b) => b.blob_type === "menu_preface");
      if (this.menuPreface) {
        this.preface = this.menuPreface.data;
        this.prefaceInput =
          this.preface[this.contentLang] || this.preface.preface;
      }
    },
    getBlobs() {
      if (!this.role) return this.warningAlert("Invalid Role");
      this.loading = true;
      this.$store
        .dispatch("getBlobsForWorkflow", this.role.workflow_id)
        .then((res) => {
          console.log("getBlobsForWorkflow", res);
          if (res.data) this.initBlobs(res.data); // if there are blobs, initialise them
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.loading = false));
    },

    // this.updatingWebsite = true;
    // var obj = { website: this.website };
    // this.$store
    //   .dispatch("updateBusiness", {
    //     id: this.business.id,
    //     data: obj,
    //   })
    //   .then((res) => {
    //     this.successToast("Updated website");
    //     this.business.data = res.data.data;
    //   })
    //   .catch((err) => this.apiError(err))
    //   .finally(() => (this.updatingWebsite = false));

    savePreface(isDelete) {
      if (isDelete) {
        this.preface = {};
      } else {
        this.preface[this.contentLang] = this.prefaceInput; // set the lang
        if (!this.preface.preface || this.isPrefaceDefault) {
          this.preface.preface = this.prefaceInput; // set default
        }
      }

      // prepare the menu_preface object
      if (this.menuPreface) {
        this.menuPreface.data = this.preface;
      } else {
        this.menuPreface = {
          parent_type: "workflow",
          parent_id: this.role.workflow_id,
          blob_type: "menu_preface",
          data: this.preface,
        };
      }
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("saveBlob", this.menuPreface)
        .then((res) => {
          this.menuPreface = res.data; // need to update here else another save will create duplicate
          this.successToast("Menu preface saved!");
          this.editingPreface = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  margin-top: 8px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.hint {
  margin-top: 6px;
  margin-left: 4px;
  color: grey;
  font-size: 0.9em;
}
</style>
